import React, { useState } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { getDatabase, ref, push } from 'firebase/database';

const QuestionsPage = () => {
  const [viewType, setViewType] = useState('add');

  const AddQuestion = () => {
    const [questionData, setQuestionData] = useState({
      subject: '',
      type: 'MCQ',
      question: '',
      options: ['', '', '', ''],
      correctAnswer: '',
      marks: ''
    });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const db = getDatabase();
        await push(ref(db, 'questions'), questionData);
        alert('Question added successfully!');
        setQuestionData({
          subject: '',
          type: 'MCQ',
          question: '',
          options: ['', '', '', ''],
          correctAnswer: '',
          marks: ''
        });
      } catch (error) {
        console.error('Error adding question:', error);
        alert('Error adding question');
      }
    };

    return (
      <Card style={{ borderRadius: '15px' }}>
        <Card.Body>
          <h4>Add New Question</h4>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    value={questionData.subject}
                    onChange={(e) => setQuestionData({...questionData, subject: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Question Type</Form.Label>
                  <Form.Select
                    value={questionData.type}
                    onChange={(e) => setQuestionData({...questionData, type: e.target.value})}
                  >
                    <option>MCQ</option>
                    <option>True/False</option>
                    <option>Descriptive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {/* Add more form fields */}
            <Button type="submit" variant="primary">Add Question</Button>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '30px', color: '#1976d2', fontWeight: '700' }}>Question Bank</h2>
      
      <div className="d-flex gap-2 mb-4">
        <Button 
          variant={viewType === 'add' ? 'primary' : 'outline-primary'}
          onClick={() => setViewType('add')}
        >
          Add Questions
        </Button>
        <Button 
          variant={viewType === 'bank' ? 'primary' : 'outline-primary'}
          onClick={() => setViewType('bank')}
        >
          Question Bank
        </Button>
      </div>

      {viewType === 'add' && <AddQuestion />}
      {viewType === 'bank' && (
        <Card style={{ borderRadius: '15px' }}>
          <Card.Body>
            <h4>Question Bank</h4>
            {/* Add question bank view content */}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default QuestionsPage;
